module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Nusshof-42c45891920e6e44daa328fcd8fdfa15.svg";